import { ComponentType, createElement } from 'react';

export const displayNewLines = (
  text: string,
  element: ComponentType | string = 'p'
) => {
  const lines = text.split('\n');
  return lines.map((line) => createElement(element, null, [line]));
};
